import { render, staticRenderFns } from "./ModalConfirmNewTicket.vue?vue&type=template&id=de2a7074"
import script from "./ModalConfirmNewTicket.vue?vue&type=script&lang=js"
export * from "./ModalConfirmNewTicket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports